module.exports = __webpack_public_path__ + "static/media/restoran-gril-3.55b72883.jpg";